/*
Door Hinges

  --type <string:: enum> | ['Five-Knuckle', 'Top Pivot', 'Bottom Pivot', 'Intermediate Pivot', 'Top & Bottom Pivot']
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Hinges'
const id = 'IMoBCWPKL16E8mTW8f0B'

export default {
  name,
  id,
  filters,
  headers,
  form
}
